import { useQuery } from '@apollo/client';
import { createError } from '@common/neo.tax';

import { GetProductsQuery, GetProductsQueryVariables, GET_PRODUCTS } from '../graphql';
import { useCurrentCompanyId } from './useCurrentCompanyId';

export type Product = GetProductsQuery['getProducts'][number];

export const useProducts = (): {
  products: Product[];
  loading: boolean;
} => {
  const companyId = useCurrentCompanyId();
  const { data, loading } = useQuery<GetProductsQuery, GetProductsQueryVariables>(GET_PRODUCTS, {
    variables: { companyId },
  });
  if (loading) {
    return { products: [], loading };
  }
  if (!data) {
    throw createError('UseProductsError', 'Failed to fetch products');
  }
  return { products: data.getProducts, loading };
};
